// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/icing-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/icing-hazards/icing-hazards.js';

mount([g0]);
